import { makeStyles } from "@material-ui/core/styles";

export const useSettingsStyles = makeStyles(theme => ({
  navbar: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap",
      overflowX: "auto",
      flexDirection: "row",
    },
  },

  root: {
    minHeight: "100vh",
    backgroundColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "0 20px",
  },
  logoContainer: {
    display: "none",
  },
  logo: {
    width: "200px",
    height: "120px",
    objectFit: "contain",
  },
  credentialsHeader: {
    color: "#747474",
    padding: "0 0 12px",
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  sideMenuItem: {
    height: "50px",
    textWrap: "no-space",
    padding: 0,
    paddingLeft: "17.25px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  sideMenuItemActive: {
    backgroundColor: "#131313!important",
    borderRadius: "8px",
    paddingLeft: "17.25px",
    "& $label": {
      color: "#FF78AA",
    },
    "& $icon path": {
      stroke: "#FF78AA",
    },
  },
  icon: {
    color: "#FFFFFFCC",
    marginRight: "8px",
    width: "24px",
    height: "24px",
    transition: "color 0.3s ease",
    "& path": {
      stroke: "#FFFFFFCC",
      transition: "fill 0.3s ease, stroke 0.3s ease",
    },
    [theme.breakpoints.down("sm")]: {
      width: "16px",
      height: "16px",
    },
  },
  activeIcon: {
    "& path": {
      stroke: "#FF78AA",
    },
  },
  label: {
    color: "#FFFFFFCC",
    transition: "color 0.3s ease",
    fontSize: "20px",
    fontWeight: 400,
    fontFamily: "Work Sans, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  hoverEffect: {
    "&:hover": {
      "& svg path": {
        stroke: "#FF78AA",
      },
      "& $label": {
        color: "#FF78AA",
      },
    },
  },
  activeText: {
    color: "#FF78AA",
  },

  pageWrapper: {
    margin: "0 auto 0 20px",
    marginTop: "24px",
    maxWidth: "1180px",
    minHeight: "967px",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      margin: "0",
    },
  },
  mainContainer: {
    display: "flex",
    gap: "20px",
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      maxWidth: "calc(100vw - 40px)",
      height: "auto",
      minHeight: "auto",
      maxHeight: "auto",
      gap: 0,
      margin: "0",
    },
  },

  sideMenu: {
    width: "380px",
    minWidth: "380px",
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      width: "250px",
      minWidth: "250px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: "100%",
      flex: "0 0 auto",
      borderBottom: "1px solid #363636",
    },
  },
  sidebarWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 36,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      maxWidth: "100vw",
      overflowX: "scroll",
    },
  },

  sidebarTitle: {
    fontSize: "40px",
    fontWeight: 700,
    color: "#ffffff",
    fontFamily: "Work Sans, sans-serif",
    marginBottom: "4px",
    lineHeight: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginTop: "20px",
    },
  },

  contentContainer: {
    flex: "1 1 auto",
    minWidth: 0,
    padding: 0,
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0",
      width: "100%",
      flex: "1 1 auto",
      padding: 0,
    },
  },

  title: {
    color: "#f06ec4",
    marginBottom: theme.spacing(4),
    fontWeight: 600,
    fontSize: "28px",
    textAlign: "center",
    fontFamily: "Work Sans, sans-serif",
  },
  footerContainer: {
    padding: "0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "auto",
    height: "104px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  footerText: {
    color: "#f06ec4",
    fontSize: "10.89px",
    fontWeight: 600,
    cursor: "pointer",
    textDecoration: "underline",
    textAlign: "center",
    lineHeight: "14px",
    letterSpacing: "0",
    fontFamily: "Work Sans, sans-serif",
  },
}));
